module.exports = __webpack_public_path__ + "static/media/icon_nav_users_active.3c41d28f.svg";